import DynamicFeedOutlined from '@mui/icons-material/DynamicFeedOutlined';
import { s } from '../../format/schema';
import { defineFieldType, noSettings } from '../card';
import { RepeatableGroupInput } from './FillInput';

export const repeatableGroup = defineFieldType({
  type: 'repeatableGroup',
  name: 'Repeatable group',
  valueKind: 'rows',
  settings: noSettings,
  defaults: {},
  canResize: () => false,
  value: s.array(s.record(s.unknown())),
  emptyValue: [],
  hasDefaultValue: false,
  validations: ['required', 'range'],
  operators: ['isFilled', 'isEmpty'],
  palette: [
    {
      name: 'Repeatable group',
      tooltip: 'Fields filled in once per row',
      group: 'Layout',
      icon: DynamicFeedOutlined,
    },
  ],
  isEmpty: value => value.length === 0,
  quantity: value => value.length,
  FillInput: RepeatableGroupInput,
  fillLabel: () => 'heading',
});
